import { Model_Datasource, AbsPaginatedGrid, BaseQueryParams, TYPE_DATASOURCE, StartupInfos_Datasource, TYPE_DATASOURCE_FILTER_OPTIONS, TYPE_COLONNE, TYPE_DONNEE, DATASOURCE_COLUMN_TYPES_OPTION, DATASOURCE_COLUMN_TYPES_DONNEES_OPTION, TYPE_DECLENCHEUR, Model_ResponseWorkflow, Model_Workflow } from 'src/app/app.models';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { catchError, map } from 'rxjs/operators';

export abstract class DatasourceService {
    loadedDatasources$ = new BehaviorSubject<Model_Datasource[]>([]);
    
    public abstract doGetDatasourceByNum(_num: string): Promise<Model_Datasource>;
    public abstract doBuildDatasourceByNumAction(_num: string): Promise<AbsPaginatedGrid<any>>;

    constructor(
        protected _httpClient: HttpClient,
        protected _apiService: ApiService,
    ) {

    }

    async doUpdateCachedDatasource(response: Model_ResponseWorkflow, workflow: Model_Workflow) {
        for (var s in workflow.WORKFLOW_STEPS) {
            const step = workflow.WORKFLOW_STEPS[s];
            for (var d in step.DECLENCHEURS) {
                const declencheur = step.DECLENCHEURS[d];
                switch(declencheur.TYPE_DECLENCHEUR) {
                    case TYPE_DECLENCHEUR.ACTION_DATASOURCE: {
                            const optionsActionDatasource = declencheur.PARAMS_DECLENCHEUR.ACTION_DATASOURCE_OPTIONS;
                            const localDatasources = this.loadedDatasources$.value;
                            let datasourceIndex = localDatasources.findIndex(d => d.NUM_DATASOURCE == optionsActionDatasource.NUM_DATASOURCE);
                            if (datasourceIndex > -1) {
                                localDatasources.splice(datasourceIndex, 1);
                            }
                            this.loadedDatasources$.next(localDatasources);
                        }
                        break;

                    case TYPE_DECLENCHEUR.ACTION_DATASOURCE_FROM_INPUT_GRID: {
                            const optionsActionDatasource = declencheur.PARAMS_DECLENCHEUR.ACTION_DATASOURCE_FROM_INPUT_GRID_OPTIONS;
                            const localDatasources = this.loadedDatasources$.value;
                            let datasourceIndex = localDatasources.findIndex(d => d.NUM_DATASOURCE == optionsActionDatasource.NUM_DATASOURCE);
                            if (datasourceIndex > -1) {
                                localDatasources.splice(datasourceIndex, 1);
                            }
                            this.loadedDatasources$.next(localDatasources);
                        }
                        break;
                }
            }
        }

        
    }

    async doLoadDatasource(_datasource: any) {
        let datasource: any = null;
        const localDatasources = this.loadedDatasources$.value;
        if (/*_datasource.IS_CACHED === undefined || */_datasource.IS_CACHED === true) {
            let datasourceIdx = localDatasources.findIndex(d => d.NUM_DATASOURCE == _datasource.NUM_DATASOURCE && d.TYPE_DATASOURCE != TYPE_DATASOURCE.WORKFLOWS);
            if (datasourceIdx !== -1) {
                //const remoteGuidCache = await this.doGetGuidCacheDatasourceAction(_datasource.NUM_DATASOURCE);
                datasource = localDatasources[datasourceIdx];
                if (/*remoteGuidCache == datasource.GUID_CACHE && */(!datasource.DS_PARAMS?.DS_PARAMETERS || datasource.DS_PARAMS?.DS_PARAMETERS.length == 0)) {
                    datasource = localDatasources[datasourceIdx];
                } else {
                    datasource = null;
                    localDatasources.splice(datasourceIdx, 1);
                    this.loadedDatasources$.next(localDatasources);
                }
            }
        }

        if (!datasource) {
            datasource = await this.doGetDatasourceByNum(_datasource.NUM_DATASOURCE);
            if (!!datasource.DS_PARAMS?.DS_PARAMETERS && _datasource.DS_PARAMETERS) {
                datasource.DS_PARAMS?.DS_PARAMETERS.forEach((dsParam, index, dsParameters) => {
                    const matchedParameter = _datasource.DS_PARAMETERS.find(p => p.NAME == dsParam.NAME);
                    if (!!matchedParameter?.DEFAULT_VALUE) {
                        dsParameters[index].DEFAULT_VALUE = matchedParameter?.DEFAULT_VALUE;
                    }
                });
            }
            const buildedDatasource = await this.doBuildGridDatasource(datasource);
            datasource.datas = buildedDatasource.AbsGrid;

            if (datasource.TYPE_DATASOURCE != TYPE_DATASOURCE.WORKFLOWS && (/*_datasource.IS_CACHED === undefined || */_datasource.IS_CACHED === true)) {
                localDatasources.push(datasource);
                this.loadedDatasources$.next(localDatasources);
            }
        }

        return datasource;
    }

    async doGetGuidCacheDatasourceAction(_numDatasource: string): Promise<string> {
        return this._httpClient.get<string>(this._apiService.endPoints.doGetGuidCacheDatasourceAction + '/' + _numDatasource, { responseType: 'text' as any })
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }

    doGetStartupInfosAction() {
        return this._httpClient.get<StartupInfos_Datasource>(this._apiService.endPoints.doGetStartupInfosAction_Datasource)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur')));
    }

    doGetDatasourcesAction(_queryParams: QueryParams_Datasource) {
        let httpParams = new HttpParams();
        Object.keys(_queryParams).forEach(k => httpParams = httpParams.set(k, _queryParams[k]));

        return this._httpClient.get<Model_Datasource[]>(this._apiService.endPoints.doGetDatasourcesAction_Datasource, {params: httpParams})
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur')));
    }

    doSaveDatasourceAction(_datasource: Model_Datasource) {
        return this._httpClient.post<Model_Datasource>(this._apiService.endPoints.doSaveDatasourceAction_Datasource, _datasource)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur')));
    }

    doGetTypeDatasource(_datasource: Model_Datasource) {
        return TYPE_DATASOURCE_FILTER_OPTIONS.find(t => t.mVALUE_MEMBER == _datasource.TYPE_DATASOURCE)?.mDISPLAY_MEMBER;
    }

    doDeleteDatasourceAction(_id: string) {
        return this._httpClient.post<void>(this._apiService.endPoints.doDeleteDatasourceAction_Datasource + '/' + _id, {})
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur')));
    }

    doBuildGridDatasourceByNum(_datasource: Model_Datasource) {
        return new Promise<{ Columns: any[], AbsGrid: AbsPaginatedGrid<any> }>((resolve, reject) => {
            this.doBuildDatasourceByNumAction(_datasource.NUM_DATASOURCE).then(_grid => {
                const columns = _grid.mAbsColumns.filter(column => column.mVisible).map(column => ({
                    prop: column.mDatasource,
                    name: column.mTitle,
                    hasCustomHtml: column.mHasCustomHtml,
                    typeDonnees: column.mTypeDonnees
                }));
                const absGrid = _grid;
                resolve({ Columns: columns, AbsGrid: absGrid }); 
            }, (error: string) => {
                reject(error);
            });
        })
    }

    doBuildGridDatasource(_datasource: Model_Datasource, inDesigner?: boolean) {
        _datasource.datas = null;
        let httpParams = new HttpParams();
        if (inDesigner === true) { httpParams = httpParams.set('inDesigner', '1'); }
        return this._httpClient.post<AbsPaginatedGrid<any>>(this._apiService.endPoints.doBuildDatasourceAction, _datasource, { params: httpParams })
        .pipe(map(_grid => {
            let columns: any[] = [];
            if (_datasource.TYPE_DATASOURCE != TYPE_DATASOURCE.JSON) {
                columns = _grid.mAbsColumns.filter(column => column.mVisible).map(column => ({
                    prop: column.mDatasource,
                    name: column.mTitle,
                    hasCustomHtml: column.mHasCustomHtml,
                    typeDonnees: column.mTypeDonnees
                }));
            }
            const absGrid = _grid;
            return { Columns: columns, AbsGrid: absGrid };
        }), catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }

    doGetDatasourceColumnTypeDatasource(_typeColumn: TYPE_COLONNE) {
        return DATASOURCE_COLUMN_TYPES_OPTION.find(t => t.mVALUE_MEMBER == _typeColumn)?.mDISPLAY_MEMBER;
    }

    doGetDatasourceColumnTypeDonneesDatasource(_typeDonnees: TYPE_DONNEE) {
        return DATASOURCE_COLUMN_TYPES_DONNEES_OPTION.find(t => t.mVALUE_MEMBER == _typeDonnees)?.mDISPLAY_MEMBER;
    }

    doGetTypeDatasourceIcon(_datasource: Model_Datasource) {
        let icon = 'reader-outline';
        switch(_datasource.TYPE_DATASOURCE) {
            case TYPE_DATASOURCE.TABLE_RUNNER:
                icon = 'cube-outline'
                break;

            case TYPE_DATASOURCE.SQL_VIEW:
                icon = 'server-outline'
                break;

            case TYPE_DATASOURCE.TABLE_RUNNER:
                icon = 'layers-outline'
                break;

            case TYPE_DATASOURCE.WORKFLOWS:
                icon = 'git-compare-outline'
                break;
        }
        return icon;
    }

    doLockDatasourceAction(_datasource: Model_Datasource) {
        return this._httpClient.post<void>(this._apiService.endPoints.doLockDatasourceAction_Datasource + '/' + _datasource.ID, {})
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }

    doUnlockDatasourceAction(_datasource: Model_Datasource) {
        return this._httpClient.post<void>(this._apiService.endPoints.doUnlockDatasourceAction_Datasource + '/' + _datasource.ID, {})
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }

    doExportDatasourceDatasAction(_datasource: Model_Datasource) {
        return this._httpClient.get<Blob>(this._apiService.endPoints.doExportDatasourceDatasAction + '/' + _datasource.NUM_DATASOURCE, { responseType: 'blob' as any })
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }
}

export class QueryParams_Datasource extends BaseQueryParams {
    TYPE_DATASOURCE: TYPE_DATASOURCE = TYPE_DATASOURCE.ALL;
}